// extracted by mini-css-extract-plugin
export default {"container":"_p-z","brandName":"aq-z","productName":"bq-z","productNamePdpEnhancements":"cq-z","breakLongProductName":"dq-z"};